import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4 border-bottom" }
const _hoisted_5 = { class: "d-flex align-items-center gap-3" }
const _hoisted_6 = { class: "position-relative table-src-form me-0" }
const _hoisted_7 = { class: "default-table-area style-two default-table-width" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle mb-0" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "text-muted fs-13" }
const _hoisted_13 = { class: "d-flex align-items-center gap-2" }
const _hoisted_14 = { class: "fw-bold text-dark fs-14" }
const _hoisted_15 = { class: "text-muted fs-12" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "text-muted fs-12 fst-italic"
}
const _hoisted_19 = {
  key: 0,
  class: "badge bg-warning bg-opacity-20 text-warning-emphasis fs-12 px-2 py-1 d-inline-flex align-items-center gap-1"
}
const _hoisted_20 = ["onClick", "disabled"]
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = { class: "material-symbols-outlined fs-14" }
const _hoisted_24 = { class: "fs-12 text-muted" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "d-inline-flex gap-1" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = { class: "custom-modal-card card border-0 shadow-lg" }
const _hoisted_30 = { class: "card-header bg-white d-flex justify-content-between align-items-center py-3 px-4 border-bottom" }
const _hoisted_31 = { class: "mb-0 fs-16 fw-semibold text-dark d-flex align-items-center gap-2" }
const _hoisted_32 = { class: "material-symbols-outlined fs-20 text-primary" }
const _hoisted_33 = { class: "card-body p-4" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "form-label fs-13 fw-semibold text-dark" }
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = ["required"]
const _hoisted_40 = {
  key: 0,
  class: "mt-3 p-3 border rounded-3 bg-light text-center"
}
const _hoisted_41 = { class: "signature-preview-card p-3 mx-auto bg-white rounded border d-inline-block shadow-sm" }
const _hoisted_42 = { class: "fs-12 text-primary fw-bold mb-1" }
const _hoisted_43 = { class: "signature-render-wrap my-2" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "fs-13 fw-bold text-dark text-decoration-underline" }
const _hoisted_46 = { class: "fs-11 text-muted" }
const _hoisted_47 = { class: "row mt-3 pt-3 border-top" }
const _hoisted_48 = { class: "col-md-6 mb-2" }
const _hoisted_49 = { class: "form-check form-switch" }
const _hoisted_50 = { class: "col-md-6 mb-2" }
const _hoisted_51 = { class: "form-check form-switch" }
const _hoisted_52 = { class: "card-footer bg-light d-flex justify-content-end gap-2 py-3 px-4" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_56 = {
  key: 1,
  class: "material-symbols-outlined fs-18"
}
const _hoisted_57 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_58 = {
  class: "p-4 border rounded-3 bg-light d-flex align-items-center justify-content-center",
  style: {"min-height":"180px"}
}
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "mt-3 text-center" }
const _hoisted_61 = { class: "fw-bold fs-15 text-dark" }
const _hoisted_62 = { class: "text-muted fs-13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Penandatangan Protokol",
      subTitle: "Pengesahan Dokumen"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("div", null, [
            _createElementVNode("h5", { class: "mb-1 fs-16 fw-semibold text-dark" }, "Daftar Pejabat Penandatangan Protokol"),
            _createElementVNode("p", { class: "text-muted fs-13 mb-0" }, "Kelola nama, jabatan, dan gambar tanda tangan digital yang digunakan pada pengesahan sertifikat protokol resmi (RC-SIM, RC-GRM, RC-AI).")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Cari nama atau jabatan...",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args))),
              class: "btn btn-primary py-2 px-3 fs-14 fw-medium rounded-3 d-flex align-items-center gap-1"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "add", -1),
              _createElementVNode("span", null, "Tambah Penandatangan", -1)
            ]))
          ])
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "p-3 bg-light-subtle border-bottom fs-13 text-muted d-flex align-items-center gap-2" }, [
          _createElementVNode("i", { class: "material-symbols-outlined fs-18 text-primary" }, "verified_user"),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, "Integritas Dokumen Legal:"),
            _createTextVNode(" Penandatangan berstatus "),
            _createElementVNode("strong", null, "Default"),
            _createTextVNode(" akan otomatis dipilih saat form protokol dibuka. Perubahan data di sini tidak akan merusak snapshot tanda tangan pada protokol lama yang sudah terbit. ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"width":"50px"}
                  }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"220px"}
                  }, "Pejabat Penandatangan"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"170px"}
                  }, "Tanda Tangan"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"140px"}
                  }, "Status Default"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"120px"}
                  }, "Status Aktif"),
                  _createElementVNode("th", {
                    scope: "col",
                    style: {"min-width":"140px"}
                  }, "Dibuat"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-end",
                    style: {"min-width":"120px"}
                  }, "Aksi")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _cache[17] || (_cache[17] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "text-center py-5 text-muted"
                      }, [
                        _createElementVNode("div", {
                          class: "spinner-border spinner-border-sm text-primary me-2",
                          role: "status"
                        }),
                        _createTextVNode(" Memuat data penandatangan... ")
                      ], -1)
                    ])))
                  : (_ctx.filteredSignatories.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _cache[18] || (_cache[18] = [
                        _createElementVNode("td", {
                          colspan: "7",
                          class: "text-center py-5 text-muted"
                        }, " Tidak ada penandatangan protokol yang ditemukan. ", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredSignatories, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", _hoisted_12, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_13, [
                              _cache[19] || (_cache[19] = _createElementVNode("div", {
                                class: "rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center",
                                style: {"width":"38px","height":"38px","flex-shrink":"0"}
                              }, [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-20" }, "badge")
                              ], -1)),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_15, _toDisplayString(item.position), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (item.signature_image_url || item.signature_image)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "signature-thumb-box",
                                  onClick: ($event: any) => (_ctx.zoomSignature(item)),
                                  title: "Klik untuk memperbesar"
                                }, [
                                  _createElementVNode("img", {
                                    src: _ctx.getFileUrl(item.signature_image_url || item.signature_image),
                                    alt: "Tanda Tangan",
                                    class: "signature-thumb-img"
                                  }, null, 8, _hoisted_17),
                                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "zoom-badge" }, [
                                    _createElementVNode("i", { class: "material-symbols-outlined fs-14" }, "zoom_in")
                                  ], -1))
                                ], 8, _hoisted_16))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, "Tanpa gambar"))
                          ]),
                          _createElementVNode("td", null, [
                            (item.is_default)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _cache[21] || (_cache[21] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-14" }, "star", -1),
                                  _createElementVNode("span", null, "Default", -1)
                                ])))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.handleSetDefault(item)),
                                  class: "btn btn-sm btn-outline-secondary fs-11 py-1 px-2",
                                  disabled: _ctx.actionLoadingId === item.id
                                }, [
                                  (_ctx.actionLoadingId === item.id)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                                    : _createCommentVNode("", true),
                                  _cache[22] || (_cache[22] = _createTextVNode(" Jadikan Default "))
                                ], 8, _hoisted_20))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.handleToggleActive(item)),
                              class: _normalizeClass(["btn btn-sm border-0 px-2 py-1 fs-12 d-inline-flex align-items-center gap-1", item.is_active ? 'badge bg-success bg-opacity-10 text-success' : 'badge bg-danger bg-opacity-10 text-danger']),
                              disabled: _ctx.actionLoadingId === item.id
                            }, [
                              _createElementVNode("i", _hoisted_23, _toDisplayString(item.is_active ? 'check_circle' : 'cancel'), 1),
                              _createElementVNode("span", null, _toDisplayString(item.is_active ? 'Aktif' : 'Non-Aktif'), 1)
                            ], 10, _hoisted_22)
                          ]),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.formatDate(item.created_at)), 1),
                          _createElementVNode("td", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.openEditModal(item)),
                                class: "btn btn-sm btn-outline-primary p-1 d-inline-flex align-items-center",
                                title: "Edit Penandatangan"
                              }, _cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16" }, "edit", -1)
                              ]), 8, _hoisted_27),
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => (_ctx.handleDelete(item)),
                                class: "btn btn-sm btn-outline-danger p-1 d-inline-flex align-items-center",
                                title: "Hapus / Arsipkan",
                                disabled: item.is_default
                              }, _cache[24] || (_cache[24] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16" }, "delete", -1)
                              ]), 8, _hoisted_28)
                            ])
                          ])
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-modal-backdrop",
          onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h5", _hoisted_31, [
                _createElementVNode("i", _hoisted_32, _toDisplayString(_ctx.isEditing ? 'edit_square' : 'person_add'), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.isEditing ? 'Edit Penandatangan' : 'Tambah Penandatangan Baru'), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              })
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSignatory && _ctx.saveSignatory(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold text-dark" }, [
                    _createTextVNode(" Nama Lengkap & Gelar "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                    placeholder: "cth: Yulfitri, SKM., MPH",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.name]
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("small", { class: "text-muted" }, "Nama yang tercantum resmi di atas garis tanda tangan.", -1))
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold text-dark" }, [
                    _createTextVNode(" Jabatan Resmi "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.position) = $event)),
                    placeholder: "cth: Direktur PT Raya Berdikari Nusantara",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.position]
                  ]),
                  _cache[30] || (_cache[30] = _createElementVNode("small", { class: "text-muted" }, "Jabatan atau kapasitas pengesahan dalam sertifikat protokol.", -1))
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, [
                    _cache[31] || (_cache[31] = _createTextVNode(" File Gambar Tanda Tangan ")),
                    (!_ctx.isEditing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    class: "form-control",
                    ref: "fileInputRef",
                    accept: "image/png, image/jpeg, image/jpg, image/webp, image/svg+xml",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                    required: !_ctx.isEditing && !_ctx.form.signature_file
                  }, null, 40, _hoisted_39),
                  _cache[33] || (_cache[33] = _createElementVNode("small", { class: "text-muted d-block mt-1" }, [
                    _createTextVNode(" Format: "),
                    _createElementVNode("strong", null, "PNG (latar belakang transparan direkomendasikan)"),
                    _createTextVNode(" atau JPG/WebP. Maks. 2MB. ")
                  ], -1)),
                  (_ctx.previewUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-muted fs-11 text-uppercase fw-semibold mb-2" }, "Simulasi Tampilan Pada Sertifikat Protokol:", -1)),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, "Pengesahan " + _toDisplayString(_ctx.form.position || 'Jabatan'), 1),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("img", {
                              src: _ctx.getFileUrl(_ctx.previewUrl),
                              alt: "Preview Tanda Tangan",
                              class: "signature-render-img"
                            }, null, 8, _hoisted_44)
                          ]),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.form.name || 'Nama Penandatangan'), 1),
                          _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.form.position || 'Jabatan Penandatangan'), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "signatoryActiveCheck",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.is_active) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.is_active]
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("label", {
                        class: "form-check-label fs-13 fw-semibold",
                        for: "signatoryActiveCheck"
                      }, "Status Aktif", -1))
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("small", { class: "text-muted fs-11" }, "Hanya penandatangan aktif yang muncul di pilihan form protokol.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "signatoryDefaultCheck",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.is_default) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.is_default]
                      ]),
                      _cache[36] || (_cache[36] = _createElementVNode("label", {
                        class: "form-check-label fs-13 fw-semibold",
                        for: "signatoryDefaultCheck"
                      }, "Jadikan Default", -1))
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("small", { class: "text-muted fs-11" }, "Otomatis dipilih secara default saat admin membuat protokol baru.", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary px-3",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  disabled: _ctx.saving
                }, " Batal ", 8, _hoisted_53),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary px-4 d-flex align-items-center gap-2",
                  disabled: _ctx.saving
                }, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55))
                    : (_openBlock(), _createElementBlock("i", _hoisted_56, "save")),
                  _createElementVNode("span", null, _toDisplayString(_ctx.isEditing ? 'Simpan Perubahan' : 'Simpan Penandatangan'), 1)
                ], 8, _hoisted_54)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.zoomItem)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "custom-modal-backdrop",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.zoomItem = null))
        }, [
          _createElementVNode("div", {
            class: "card border-0 shadow-lg p-4 text-center bg-white",
            style: {"max-width":"480px","width":"90%"},
            onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_57, [
              _cache[38] || (_cache[38] = _createElementVNode("h6", { class: "mb-0 fw-bold text-dark" }, "Tanda Tangan Digital", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.zoomItem = null))
              })
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("img", {
                src: _ctx.getFileUrl(_ctx.zoomItem.signature_image_url || _ctx.zoomItem.signature_image),
                alt: "Tanda Tangan",
                style: {"max-height":"140px","max-width":"100%","object-fit":"contain"}
              }, null, 8, _hoisted_59)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.zoomItem.name), 1),
              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.zoomItem.position), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}